export const it = {
    // Login
    loginTitle: 'Benvenuto',
    loginMessage: 'Inserisci il tuo Login',
    username: 'Nome utente',
    email: 'Email',
    password: 'Password',
    newPassword: 'Nuova Password',
    repeatNewPassword: 'Ripeti la Nuova Password',
    authenticateUser: 'Autentica Utente',
    recoverPassword: 'Recupera Password',
    recoverPasswordDescription: 'Controlla la tua Email e segui le istruzioni per reimpostare la tua Password',
    forgotPassword: 'Password dimenticata',
    code: 'Codice',
    acceptWordOs: 'Accetta',
    acceptWordAs: 'Accetta',
    termsConditions: 'Termini e Condizioni',
    cookies: 'Politica sui Cookie',
    privacyRule: 'Accetta',
    privacyRuleLink: 'Riservatezza dei Dati',
    repeatPasswordLabel: 'Ripeti la Password usata sopra',
    inputLabelNewPassword: 'La Password deve rispettare i requisiti',
    logout: 'Esci',
    'User Authenticated': 'Utente Autenticato',

    //---- Nav Bar Items-----
    inicio: 'Home',
    municipality: 'Municipio',
    territory: 'Territorio',
    autarchy: 'Autarchia',
    entity: 'Entità',
    emissions: 'Emissioni di GEE nel Territorio',

    map: 'Mappa',
    politicas: 'Politiche',
    events: 'Eventi',
    registry: 'Registro',
    registrationManagement: 'Gestione della Registrazione',
    searchForAsset: 'Cerca per Asset',
    searhForResource: 'Cerca per Codice Asset',
    Energy: 'Energia',
    analytics: 'Analisi',
    timeLine: 'Cronologia',

    configurations: 'Configurazioni',

    //----- Buttons --------
    seeOnMap: 'Vedi sulla Mappa',
    delete: 'Elimina',
    add: 'Aggiungi',
    clear: 'Cancella',
    lines: 'Linee',
    bars: 'Barre',
    heatmap: 'HeatMap',
    report: 'Rapporto',
    exportRawData: 'Esporta Dati Grezzi',
    signIn: 'Accedi',
    resetPassword: 'Reimposta Password',
    sendEmail: 'Invia Email',
    edit: 'Modifica',
    submit: 'Invia',
    cancel: 'Annulla',
    save: 'Salva',
    seeDetail: 'Vedi Dettaglio',
    upload: 'Carica',
    deleteDescription: 'Sei sicuro di voler eliminare l’elemento?',
    "Show Metrics": "Mostra Metriche",

    //------------
    search: 'Cerca',
    selectPeriod: 'Seleziona Periodo',

    //------ Date Formats -----
    day: 'giorno',
    days: 'Giorni',
    week: 'Settimana',
    weeks: 'Settimane',
    months: 'Mesi',
    year: 'Anno',
    years: 'Anni',
    hourly: 'Ogni Ora',
    daily: 'Quotidiano',
    weekly: 'Settimanale',
    startDate: 'Data di Inizio',
    endDate: 'Data di Fine',
    annual: 'Annuale',
    monthly: 'Mensile',
    quarter: 'Trimestre',
    yearly: 'Annuale',
    raw: 'Grezzo',

    jan: 'gen',
    feb: 'feb',
    mar: 'mar',
    apr: 'apr',
    may: 'mag',
    jun: 'giu',
    jul: 'lug',
    aug: 'ago',
    sep: 'set',
    oct: 'ott',
    nov: 'nov',
    dec: 'dic',
    January: "Gennaio",
    February: "Febbraio",
    March: "Marzo",
    April: "Aprile",
    May: "Maggio",
    June: "Giugno",
    July: "Luglio",
    August: "Agosto",
    September: "Settembre",
    October: "Ottobre",
    November: "Novembre",
    December: "Dicembre",

    "Monday": "Lunedì",
    "Tuesday": "Martedì",
    "Wednesday": "Mercoledì",
    "Thursday": "Giovedì",
    "Friday": "Venerdì",
    "Saturday": "Sabato",
    "Sunday": "Domenica",

    //------------
    data: 'Dati',
    name: 'Nome',

    simple: 'Semplice',
    biHourly: 'Ogni due ore',
    triHourly: 'Ogni tre ore',
    tetraHourly: 'Ogni quattro ore',

    page: 'Pagina',
    seeMore: 'Vedi Altro',
    seeLess: 'Vedi Meno',
    'and others': 'e altri',

    simulatedTariffs: 'Tariffe Simulate',
    Floor1: "1° Piano",
    Floor2: "2° Piano",
    Floor3: "3° Piano",
    Floor4: "4° Piano",
    Floor5: "5° Piano",
    Floor6: "6° Piano",
    Floor7: "7° Piano",
    Floor8: "8° Piano",
    Floor9: "9° Piano",
    Floor10: "10° Piano",

    //------------ Tooltips -----------
    passwordRequirements: 'Requisiti della password',
    minimunCharacters: 'Minimo 8 caratteri',
    numberCharacter: 'Contiene almeno 1 numero',
    uppercaseLetter: 'Contiene almeno 1 lettera maiuscola',
    lowercaseLetter: 'Contiene almeno 1 lettera minuscola',
    specialCharacter: 'Contiene almeno 1 carattere speciale',
    dataBasedEReded: 'Generato in base agli ultimi dati Open Data di E-REDES',
    dataRefersToYear: "I dati si riferiscono all'anno di ",
    comparingElectricityConsumption: 'Confronto del consumo di elettricità',
    heatmapExplained: 'Mappa di calore generata utilizzando il consumo delle stazioni di trasformazione del territorio',
    heatmapTooltip: 'Mappa di calore che mostra la densità del consumo di elettricità del territorio',
    "The graph shows the average data for the last four weeks, grouped by each day of the week. Each point reflects the average of the values recorded on a given day over the last four weeks, allowing daily trends to be observed.": 'Il grafico mostra i dati medi delle ultime quattro settimane, raggruppati per ogni giorno della settimana. Ogni punto riflette la media dei valori registrati in un determinato giorno, consentendo di osservare le tendenze giornaliere.',
    "Percentage reflects bookings in relation to the number of seats available": 'La percentuale riflette le prenotazioni in relazione al numero di posti disponibili',
    'Periodicity Tooltip': 'Mostra le ultime 12 ore della data selezionata',
    "Drawer Weight Tooltip": "Peso dell'elemento, che rappresenta la percentuale di impatto che un problema ha sul nodo figlio",
    "Drawer Is Peer Tooltip": 'Relazione di parità, che indica se la relazione è tra nodi dello stesso livello gerarchico o di tipo padre-figlio',
    "Drawer Invname Tooltip": 'Nome del nodo figlio della relazione',
    "Drawer Outvname Tooltip": 'Nome del nodo padre della relazione',
    "tooltip.incident_category_description": "Il campo categoria avrà un valore solo se è stato selezionato prima un Servizio Urbano",

    //------------ AuthContext Errors -----------
    incorrectFields: 'Nome utente o password errati',
    passwordNoMatch: 'Le password non corrispondono',
    passwordNotValid: 'La password non soddisfa i requisiti',
    emailSentCode: 'Email inviata con il codice di verifica',
    codeSentByMessage: 'Codice inviato tramite messaggio',
    firstLogin: "Primo accesso, è necessario autenticare l'utente",
    errorResetPassword: 'Qualcosa è andato storto, controlla il codice o i requisiti della password',
    infoDescription: 'Impossibile esportare quando non ci sono dati disponibili',

    error: 'Errore',
    success: 'Successo',
    warning: 'Avviso',
    info: 'Informazioni',

    successAdd: 'Elementi aggiunti con successo.',
    errorAdd: 'Errore: elemento non aggiunto.',

    successDelete: 'Elementi eliminati con successo.',
    errorDelete: 'Errore: elemento non eliminato.',

    errorGettingCertificates: "Si è verificato un errore durante l'ottenimento dell'elenco dei certificati.",

    //--------------------- Filters -----------------
    filters: 'Filtri',
    rester: 'Reimposta',
    savedFilters: 'Filtri salvati',
    apply: 'Applica',
    "All": 'Tutti',
    "Clear Options": 'Cancella opzioni',

    //--------------------- Classes -----------------
    "Buildings": 'Edifici',
    "Facilities": 'Strutture',

    //--------------------- Classes -----------------
    "Office": 'Ufficio',
    "Social": 'Sociale',
    "Pavilion": 'Padiglione',
    "School": 'Scuola',
    "Storage": 'Magazzino',
    "Meeting Room": 'Sala riunioni',
    "Expresso Corner": 'Area relax',
    "Level Floor": 'Piano livello',

    //--------------------- Home -----------------
    "Total Buildings": 'Edifici totali',
    "Types of Buildings": 'Tipi di edifici',
    "General Information of Buildings": 'Informazioni generali sugli edifici',
    "Occupation in the Buildings": 'Occupazione negli edifici',
    "Average Occupation": 'Occupazione media',
    "Top 5 Highest Occupancy": 'Top 5 con maggiore occupazione',
    "Top 5 Lowest Occupancy": 'Top 5 con minore occupazione',
    "Top 5 Highest Consumption": 'Top 5 con maggiore consumo',
    "Top 5 Lowest Consumption": 'Top 5 con minore consumo',
    'Garage Occupation': 'Occupazione del garage',
    'Garage Number': 'Numero di garage',
    'Available Parking Spaces': 'Posti auto disponibili',
    'Medium Occupation': 'Occupazione media',
    'Buildings Water Consumption': 'Consumo di acqua degli edifici',
    "Current Incidents": 'Incidenti attuali',
    "Top 5 Incidents": 'Top 5 incidenti',
    "Buildings Energetic Consumption": 'Consumo energetico degli edifici',
    "Average Consumption": 'Consumo medio',
    "Energy Consumption": 'Consumo di energia',
    "Building Comfort": "Comfort dell'edificio",
    "Building Occupation": "Occupazione dell'edificio",
    "Capacity": 'Capacità',

    //--------------------- Building Details -------
    "View": 'Visualizza',
    "Overview": 'Panoramica',
    "Occupation": 'Occupazione',
    "Room Detail": 'Dettaglio della stanza',
    "Comfort": 'Comfort',
    "Parking": 'Parcheggio',
    "Daily Analysis": 'Analisi giornaliera',
    "Historic": 'Storico',
    "Buildings Detail": 'Dettagli degli edifici',
    "Digital Twin": 'Gemello digitale',
    "Energetic Consumption": 'Consumo energetico',
    "Average Energy Consumption": 'Consumo energetico medio',
    "Energy consumption per user": 'Consumo energetico per utente',
    "Evolution of floor energy consumption": 'Evoluzione del consumo energetico del piano',
    "Consumption per Hour": 'Consumo per ora',
    "Energy Consumption per user": 'Consumo energetico per utente',
    "Building Energy Consumption Evolution": "Evoluzione del consumo energetico dell'edificio",
    "Peak of the month": 'Picco del mese',
    "Evolution of floor energy consumption during the day": 'Evoluzione del consumo energetico del piano durante il giorno',
    "Room Details": 'Dettagli della stanza',
    "Vacant Rooms": 'Stanze libere',
    "Vacant": 'Libero',
    "Check-In and Room Reservation": 'Check-In e Prenotazione Stanza',
    "Room Occupation": 'Occupazione della stanza',
    "Lighting": 'Illuminazione',
    "Temperature": 'Temperatura',
    "Humidity": 'Umidità',
    "Air Quality": "Qualità dell'aria",
    "Noise": 'Rumore',
    "Luminosity": 'Luminosità',
    "Building": 'Edificio',
    "Floor": 'Piano',
    "Average Value": 'Valore medio',
    "Average Ideal Temperature": 'Temperatura ideale media',
    "Ideal Value": 'Valore ideale',
    "Temperature Variation": 'Variazione di temperatura',
    "Humidity Variation": 'Variazione di umidità',
    "Air Quality Variation": "Variazione della qualità dell'aria",
    "Lightning Variation": 'Variazione di illuminazione',
    "Noise Variation": 'Variazione del rumore',
    "Lighting Variation": 'Variazione di illuminazione',
    "Average Reservations Made": 'Prenotazioni medie effettuate',
    "Average Check-ins Made": 'Check-in medi effettuati',
    "Average Missing Checkout": 'Checkout mancanti medi',
    "Rooms Reservations": 'Prenotazioni stanze',
    "Rooms Check-in Carried Out": 'Check-in stanze effettuati',
    "Seats Reservation": 'Prenotazione posti',
    "Map Occupation": "Mappa dell'occupazione",
    "Average Use Of Rooms": 'Uso medio delle stanze',
    "Total Reservations": 'Prenotazioni totali',
    "Occupation Map": "Mappa dell'occupazione",
    "Check-ins Done": 'Check-in effettuati',
    "Check-outs Missing": 'Check-out mancanti',
    "Real Occupation": 'Occupazione reale',
    "Distribution of people by floor": 'Distribuzione delle persone per piano',
    "Distribution throughout the day": 'Distribuzione durante il giorno',
    "Room Reservation": 'Prenotazione stanza',
    "Check-ins Ongoing": 'Check-in in corso',
    "CPE Details": 'Dettagli CPE',
    "Top Energy": 'Energia massima',
    "Energy Consumption": 'Consumo di energia',
    "Inductive Consumption": 'Consumo induttivo',
    "Energy Produced": 'Energia prodotta',
    "Active Consumption": 'Consumo attivo',
    "Capacitive Consumption": 'Consumo capacitivo',
    "Grid Injection": 'Immissione in rete',
    "Load Diagram": 'Diagramma di carico',
    "Highest Registered Peak": 'Picco più alto registrato',
    "Daily Power Peak": 'Picco di potenza giornaliero',
    "Production Peak": 'Picco di produzione',
    "Accumulated Emissions Avoided": 'Emissioni evitate accumulate',
    "Information From Previous Period": 'Informazioni dal periodo precedente',
    "Energy vs Production": 'Energia vs Produzione',
    "Active Power and Production Power": 'Potenza attiva e potenza di produzione',
    "Inductive Power and Capacitive Power": 'Potenza induttiva e potenza capacitiva',
    "Metric occupation": 'Occupazione: ',
    "Metric temperature": 'Temperatura: ',
    "Seats Taken": 'Posti occupati',
    "Reserved Seats": 'Posti riservati',
    "Average Length of Stay": 'Durata media del soggiorno',
    "Seat Availability": 'Disponibilità di posti',
    "Total Number of Vehicles Throughout the Day": 'Numero totale di veicoli durante il giorno',
    "Occupation by Payment Type": 'Occupazione per tipo di pagamento',
    "Occupation by type of place": 'Occupazione per tipo di luogo',
    "Active Energy": 'Energia attiva',
    "Active Energy Consumption": 'Consumo di energia attiva',
    "Inductive Energy Consumption": 'Consumo di energia induttiva',
    "Capacitive Energy Consumption": 'Consumo di energia capacitiva',
    "Maximum Consumption": 'Consumo massimo',
    "Average Consumption days of the week": 'Consumo medio nei giorni della settimana',
    "Load Diagrams": 'Diagrammi di carico',
    "Export": 'Esporta',
    "It is not possible to export data for annual period": 'Non è possibile esportare dati per il periodo annuale',
    "Exportation for the selected period ": 'Esportazione per il periodo selezionato',
    "Cost Estimation": 'Stima dei costi',
    "Gas Consumption": 'Consumo di gas',
    "Associated GEE Emissions": 'Emissioni GEE associate',
    "Energetic Certification": 'Certificazione energetica',
    "Days of the week": 'Giorni della settimana',
    "Pick Power": 'Potenza di picco',
    "Average Power": 'Potenza media',
    "Saturdays and Sundays": 'Sabati e domeniche',
    "Consumption": 'Consumo',
    "Four-Hourly": 'Ogni quattro ore',
    "Empty": 'Vuoto',
    "Full": 'Pieno',
    "Edge": 'Bordo',
    "Super Empty": 'Super vuoto',
    "Provided by the grid": 'Fornito dalla rete',
    "Injected into the grid": 'Immesso nella rete',
    "Fixed Tariff Term": 'Termine tariffa fissa',
    "Contracted Power": 'Potenza contrattuale',
    "Power at Peak Hours": 'Potenza nelle ore di punta',
    "Inductive Energy": 'Energia induttiva',
    "Capacitive Energy": 'Energia capacitiva',
    "Simple": 'Semplice',
    "Bi-hourly": 'Biorario',
    "Tri-hourly": 'Triorario',
    "Tetra-hourly": 'Tetra-orario',
    "Related Assets": 'Risorse correlate',
    "Inductive": 'Induttivo',
    "Capacitive": 'Capacitivo',
    "Reactive Energy": 'Energia reattiva',
    "Power Changes": 'Cambi di potenza',
    "Peak Hours": 'Ore di punta',
    "Incident List": 'Elenco dei problemi',
    "Heatmap": 'Mappa di calore',
    "CPE Historic": 'Storico CPE',
    "Reservations": 'Prenotazioni',
    "Extended Reservations": 'Prenotazioni estese',
    "Real Occupation": 'Occupazione reale',
    "Check-in": 'Check-in',
    "Occupation": 'Occupazione',
    "Reserved Rooms": 'Stanze riservate',
    "Week Variation": 'Variazione settimanale',
    "Booked": 'Prenotato',
    "Free": 'Libero',
    "Occupied": 'Occupato',
    "Sound Level": 'Livello sonoro',
    "Light Intensity": 'Intensità luminosa',
    "Than": 'Di',
    "Invalid POI position": 'Posizione POI non valida',
    "Types of Access": 'Tipi di accesso',
    "Access": 'Accesso',
    "Reservations": 'Prenotazioni',
    "Agreements": 'Accordi',
    "Free Access": 'Accesso gratuito',
    "Reactive Inductive Energy": 'Energia reattiva induttiva',
    "Reactive Capacitive Energy": 'Energia reattiva capacitiva',
    "Active Power": 'Potenza attiva',
    "Reactive Inductive Power": 'Potenza reattiva induttiva',
    "Reactive Capacitive Power": 'Potenza reattiva capacitiva',
    "Production Power": 'Potenza di produzione',
    "Reserved": 'Riservato',
    "Inductive Reactive Energy": 'Energia reattiva induttiva',
    "Capacitive Reactive Energy": 'Energia reattiva capacitiva',
    "Average Total": 'Media totale',
    "Non-Weekend": 'Giorni feriali',
    "Weekend": 'Fine settimana',
    "Reactive Power": 'Potenza reattiva',
    "Inductive Power": 'Potenza induttiva',
    "Alerts": 'Avvisi',
    "Details": 'Dettagli',

    //--------------------- Mapa -----------------
    "Incidents": 'Incidenti',
    "Incidents Number": 'Numero di incidenti',
    "Incidents Number": 'Numero di problemi',
    "Services": 'Servizi',
    "Low": 'Basso',
    "Medium Low": 'Medio-basso',
    "Medium": 'Medio',
    "Medium High": 'Medio-alto',
    "High": 'Alto',
    "Incidents by Level": 'Incidenti per livello',
    "Field Incidents": 'Incidenti sul campo',
    "Unassigned Incidents": 'Incidenti non assegnati',
    "Select Services with Incidents": 'Seleziona servizi con incidenti',
    "Select Services": 'Seleziona servizi',
    'Select classes': 'Seleziona classi',
    "Select Priorities": 'Seleziona priorità',
    "Select Severities": 'Seleziona severità',
    "View Map": 'Visualizza mappa',
    "Quick Access": 'Accesso rapido',
    "Consumption By User": 'Consumo per utente',
    "Building Consumption": "Consumo dell'edificio",
    "Back": 'Indietro',
    "Incidents": 'Problemi',

    //--------------------- Assets -----------------
    "Assets": 'Risorse',

    //--------------------- OBJ Translations -----------------
    "Salas disponibili": 'Camere disponibili',
    "Salas occupadas": 'Camere occupate',
    "Occupied Rooms": 'Camere occupate',
    "Available Rooms": 'Camere disponibili',

    //--------------------- EVENTS -------
    "Events Severity": "Gravità degli Eventi",
    "Critical": "Critico",
    "High": "Alto",
    "Others": "Altri",
    "Events Map": "Mappa degli Eventi",
    "Event Density": "Densità degli Eventi",

    //--------------------- Configurations -------
    // "Configurations": "Configurazioni",
    "Users List": "Elenco Utenti",
    "Add": "Aggiungi",
    "Edit": "Modifica",
    "Estimated Value": "Valore Stimato",
    "Real Value": "Valore Reale",
    "Average Consumption for Homologated Period": "Consumo Medio per il Periodo Omologato",
    "Active raw power": "Potenza Attiva Lorda",
    "Maximum power allowed": "Potenza Massima Consentita",
    "Employees": "Dipendenti",
    "Clients": "Clienti",
    "Visitors": "Visitatori",
    "Contracts": "Contratti",
    "than": "di",
    "(liters)": "(litri)",
    "Widget List": "Elenco Widget",
    "Add Widget": "Aggiungi Widget",

    "day": "giorno",
    "year": "anno",
    "month": "mese",

    "button.metric_labels_configuration": "Configurazione Etichette Metriche",
    "button.system_label_mapping_configuration": "Configurazione Mappatura Etichette di Sistema",
    "Advanced Metrics": "Metriche Avanzate",

    "Tenant": "Inquilino",
    "Class": "Classe",
    "Source Table": "Tabella Fonte",

    "Detail By Name": "Dettaglio per Nome",
    "Type Number": "Numero di Tipo",
    "Class Number": "Numero di Classe",
    "Detail Number": "Numero di Dettaglio",
    "Invalid cron format.": "Formato cron non valido.",
    "Invalid Date": "Data Non Valida",

    "Source Metric Label": "Etichetta Metrica di Origine",
    "Operations": "Operazioni",
    "Operation Horizon": "Orizzonte Operativo",
    "Expression": "Espressione",
    "Destination Metric Label": "Etichetta Metrica di Destinazione",
    "Destination Metric Label Unit": "Unità Etichetta Metrica di Destinazione",
    "Metric Label": "Etichetta Metrica",
    "Unit Code": "Codice Unità",
    "Type": "Tipo",
    "Is Standard": "È Standard",
    "Conversion": "Conversione",
    "Offset": "Offset",
    "Power": "Potenza",
    "Slope": "Pendenza",
    "Standard Unit": "Unità Standard",
    "Entity": "Entità",
    "Entity Label": "Etichetta Entità",
    "Entity Unit": "Unità Entità",
    "System Label": "Etichetta di Sistema",
    "System Unit": "Unità di Sistema",
    "Metric List": "Elenco Metriche",
    "Metric Label List": "Elenco Etichette Metriche",
    "System Label Mapping List": "Elenco Mappatura Etichette di Sistema",
    "Add Metric": "Aggiungi Metrica",
    "Add Metric Label": "Aggiungi Etichetta Metrica",
    "Add System Label": "Aggiungi Etichetta di Sistema",

    "Widget Type": "Tipo di Widget",
    "Scheduler": "Pianificatore",
    "Registry": "Registro",
    "Start Time": "Ora di Inizio",
    "End Time": "Ora di Fine",
    "Metric": "Metrica",
    "Source Periodicity": "Periodicità di Origine",
    "History": "Cronologia",
    "Data Aggregation": "Aggregazione Dati",
    "Transformation": "Trasformazione",
    "Widget Dataset Name": "Nome Dataset Widget",
    "Privacy": "Privacy",
    "Description": "Descrizione",
    "Select Value": "Seleziona Valore",
    "Insert Value": "Inserisci Valore",
    "Input Text": "Testo di Input",
    "Select Items": "Seleziona Elementi",
    "Select Date": "Seleziona Data",
    "Absolute": "Assoluto",
    "Relative": "Relativo",
    "Last": "Ultimo",
    "Enter number and (day or hour)": "Inserisci numero e (giorno o ora)",
    "Enter number and (day, month or year)": "Inserisci numero e (giorno, mese o anno)",

    "Indicates the source of the data, which will be used to do any operation.": "Indica la fonte dei dati, che sarà utilizzata per eseguire qualsiasi operazione.",
    "Selection of all federated classes, i.e., all classes that are currently capable of receiving data. If any node is federated, it will be capable of receiving data.": "Selezione di tutte le classi federate, cioè tutte le classi attualmente in grado di ricevere dati. Se un nodo è federato, sarà in grado di ricevere dati.",
    "Selection of all possible data tables, i.e., all tables that <tenant>  has access, that stores or will store data.": "Selezione di tutte le tabelle dati possibili, cioè tutte le tabelle a cui <tenant> ha accesso, che memorizzano o memorizzeranno dati.",
    "Selection of all possible metrics, i.e., all metrics that <tenant>  has access. Note: It\'s possible to not have data for this metric, if the metric is only added and the data is not sent.": "Selezione di tutte le metriche possibili, cioè tutte le metriche a cui <tenant> ha accesso. Nota: È possibile che non ci siano dati per questa metrica, se la metrica è solo aggiunta e i dati non vengono inviati.",
    "This dropdown menu allows the selection of a specific data periodicity: hourly, daily, or monthly, i.e. the data will be aggregated by the specified period.": "Questo menu a discesa consente la selezione di una periodicità specifica dei dati: oraria, giornaliera o mensile, cioè i dati saranno aggregati per il periodo specificato.",
    "These fields together indicates the transformation to apply to the data (Operation + Expression) and the frequency of the data processment (Operation Horizon)": "Questi campi indicano insieme la trasformazione da applicare ai dati (Operazione + Espressione) e la frequenza del processamento dei dati (Orizzonte Operativo)",
    "Math Expression with the available functions": "Espressione Matematica con le funzioni disponibili",
    "Example of valid Expression: x+2": "Esempio di Espressione Valida: x+2",
    "Indicates the output label of the processed metric.": "Indica l'etichetta di output della metrica elaborata.",
    "Indicates the output unit of the processed metric.": "Indica l'unità di output della metrica elaborata.",

    "Expression does not contain x variable.": "L'espressione non contiene la variabile x.",
    "Success! With": "Successo! Con",
    "the result was:": "il risultato è stato:",
    "Error in Expression.": "Errore nell'Espressione.",

    "Indicates the section of the infrastructure that will be used to create the widget.": "Indica la sezione dell'infrastruttura che sarà utilizzata per creare il widget.",
    "Indicates the type of widget that will be generated. Each processes data in a unique way.": "Indica il tipo di widget che sarà generato. Ognuno elabora i dati in modo unico.",
    "String representing a cron expression. Syntax: \"minutes hours day-of-month month day-of-week year\" This will generate a schedule to update the widget according to the specified expression (in UTC).": "Stringa che rappresenta un'espressione cron. Sintassi: \"minuti ore giorno-del-mese mese giorno-della-settimana anno\" Questo genererà un programma per aggiornare il widget secondo l'espressione specificata (in UTC).",
    "Represents the type of infrastructure available, such as Buildings or Infrastructure.": "Rappresenta il tipo di infrastruttura disponibile, come Edifici o Infrastrutture.",
    "Represents the classes available for the selected type. For example, for \"Buildings\", the classes could include Administrative or Cultural Spaces.": "Rappresenta le classi disponibili per il tipo selezionato. Ad esempio, per \"Edifici\", le classi potrebbero includere Spazi Amministrativi o Culturali.",
    "Indicates if the result will contain detailed information about each data node separately. If set to True, details for each data node will be shown individually.": "Indica se il risultato conterrà informazioni dettagliate su ogni nodo dati separatamente. Se impostato su True, i dettagli per ogni nodo dati saranno mostrati individualmente.",
    "Input for start time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Input per l'ora di inizio tramite un calendario o rimuovendo fino alla data corrente. Parole Chiave Relative:(giorno/ora) Parole Chiave Ultime:(giorno/mese/anno)",
    "Input for end time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Input per l'ora di fine tramite un calendario o rimuovendo fino alla data corrente. Parole Chiave Relative:(giorno/ora) Parole Chiave Ultime:(giorno/mese/anno)",
    "The first field indicates which transformation to apply to the result from the available options. The second field is a valid mathematical expression that will be applied to the result after the transformation.": "Il primo campo indica quale trasformazione applicare al risultato tra le opzioni disponibili. Il secondo campo è un'espressione matematica valida che sarà applicata al risultato dopo la trasformazione.",
    "The field box represents the top N from the Type category.": "La casella rappresenta i primi N della categoria Tipo.",
    "The second box represents the top N from the Class category.": "La seconda casella rappresenta i primi N della categoria Classe.",
    "The third box represents the top N from the Name category.": "La terza casella rappresenta i primi N della categoria Nome.",
    "This field indicates whether the result of the widget will include historical data. If set to True, the datasets will vary according to the specified time period.": "Questo campo indica se il risultato del widget includerà dati storici. Se impostato su True, i dataset varieranno in base al periodo di tempo specificato.",
    "This setup indicates how to divide the dataset according to the specified period. These selections do not affect the transformation input. The first field represents a quantifying number, and the second field specifies whether that number is in hours, days, or months.": "Questa configurazione indica come dividere il dataset in base al periodo specificato. Queste selezioni non influenzano l'input di trasformazione. Il primo campo rappresenta un numero quantificativo e il secondo campo specifica se quel numero è in ore, giorni o mesi.",
    "An identified name for the widget": "Un nome identificato per il widget",
    "Public or Private": "Pubblico o Privato",
    "A Description for the widget": "Una Descrizione per il widget",
    "input.city_service": "Servizio Urbano",
    "input.impact": "Impatto",
    "input.latitude": "Latitudine",
    "input.longitude": "Longitudine",
    "action.create_incident": "Crea Incidente",
    "input.description": "Descrizione",
    "input.title": "Titolo",
    "input.urgency": "Urgenza",
    "notification.success_create_incident": "Incidente creato con successo",
    "notification.error_create_incident": "Errore nella creazione dell'incidente",
    "input.incident_number": "Numero di Incidente",
    "input.service_class": "Classe di Servizio",
    "input.location": "Posizione",
    "input.last_update": "Ultimo Aggiornamento",

    //--------------------- Digital Twin -------
    "Without coordinates": "Senza coordinate",
    "Level 1": "Livello 1",
    "Level 2": "Livello 2",
    "Level 3": "Livello 3",

    //--------------------- Digital Twin Metrics -------
    "Metrics": "Metriche",
    "Periodicity": "Periodicità",
    "Date": "Data",

    //--------------------- Digital Twin Drawer -------
    //Incident Drawer
    "Reference Number": "Numero di Riferimento",
    "Priority": "Priorità",
    "Category": "Categoria",
    "Service Class": "Classe di Servizio",
    "Open Date": "Data di Apertura",
    "Status": "Stato",
    //Node Drawer
    "Name": "Nome",
    "Class": "Classe",
    "Family": "Famiglia",
    "Type": "Tipo",
    "Label": "Etichetta",
    "Layer": "Livello",
    //Edge Drawer
    "Weight": "Peso",
    "Is Peer": "Relazione Peer-to-Peer",
    "Invname": "Nodo Figlio",
    "Outvname": "Nodo Genitore",
};